"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SortImg = _interopRequireDefault(require("./SortImg.vue"));
var _index = require("@/utils/index");
var _systemSetting = require("@/api/systemSetting");
var _internal = require("@/components/uploadPicture/internal.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'mainImage',
  components: {
    SortImg: _SortImg.default
  },
  data: function data() {
    return {
      visible: false,
      list: []
    };
  },
  methods: {
    open: function open() {
      var _this = this;
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.visible = true;
      this.$nextTick(function () {
        _this.list = JSON.parse(JSON.stringify(list || []));
      });
    },
    close: function close() {
      this.visible = false;
    },
    changeList: function changeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.list = data || [];
    },
    upLoad: function upLoad() {
      var that = this;

      // 计算还可以上传多少张图片
      var maxCount = 10;
      var remainingSlots = maxCount - that.list.length;
      if (remainingSlots <= 0) {
        that.$message.warning("\u6700\u591A\u53EA\u80FD\u4E0A\u4F20".concat(maxCount, "\u5F20\u56FE\u7247\uFF01"));
        return;
      }
      (0, _internal.uploadLocalImage)({
        multiple: true,
        maxCount: remainingSlots,
        model: 'product',
        pid: 1,
        validateAspectRatio: true,
        maxSizeKB: 500,
        maxSizeErrorMsg: '请上传大小≤500KB的图片！',
        onSuccess: function onSuccess(url) {
          var _that$list;
          // 上传成功，添加到图片列表
          if ((_that$list = that.list) !== null && _that$list !== void 0 && _that$list.length) {
            that.list.push(url);
          } else {
            that.list = [url];
          }
        },
        onComplete: function onComplete(successUrls) {
          if (successUrls && successUrls.length > 0) {
            that.$message.success("\u6210\u529F\u4E0A\u4F20".concat(successUrls.length, "\u5F20\u56FE\u7247"));
          } else {
            // that.$message.warning('没有图片上传成功');
          }
        },
        onError: function onError(error) {
          that.$message.error(error.message || '图片上传失败');
        }
      });
    },
    comfirm: function comfirm() {
      // 校验主图是否>=3张
      if (!this.list || this.list.length < 3) {
        this.$message.error('主图必须上传3张或以上');
        return;
      }
      this.$emit('mainImageList', this.list);
      this.close();
    }
  }
};